module.exports = __webpack_public_path__ + "static/media/Rotated tooth2.e739ad46.png";